import { render, staticRenderFns } from "./JikeMiaoMiaoXiang.vue?vue&type=template&id=2a85ba1a&scoped=true"
import script from "./JikeMiaoMiaoXiang.vue?vue&type=script&lang=js"
export * from "./JikeMiaoMiaoXiang.vue?vue&type=script&lang=js"
import style0 from "./JikeMiaoMiaoXiang.vue?vue&type=style&index=0&id=2a85ba1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85ba1a",
  null
  
)

export default component.exports